import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export default function WatchVideo() {
  const { filename } = useParams();
  const [backendUrl, setBackendUrl] = useState("");

  // Load backend URL from public/config.js
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "/config.js";
    script.onload = () => {
      if (window.env?.BACKEND_URL) {
        console.log(" BACKEND_URL loaded:", window.env.BACKEND_URL);
        setBackendUrl(window.env.BACKEND_URL);
      } else {
        console.error(" BACKEND_URL not found in config.js");
      }
    };
    script.onerror = () => console.error(" Failed to load config.js");
    document.body.appendChild(script);
  }, []);

  if (!backendUrl) {
    return <p style={{ textAlign: "center", marginTop: "50px" }}>Loading configuration...</p>;
  }

  return (
    <div style={{ padding: "20px", textAlign: "center" }}>
      <h2>🎬 Watching: {filename}</h2>
      <video
        width="90%"
        height="auto"
        controls
        controlsList="nodownload"
        disablePictureInPicture
        onContextMenu={(e) => e.preventDefault()}
        style={{ borderRadius: "8px", marginTop: "20px" }}
      >
        <source src={`${backendUrl}/video/${filename}`} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
}
